import { isVariantReadyToShip } from "./collection.utils.js";

// References for usage outside of buildProducts
let arrLength;
const productsPerPage = window.productsPerCollectionPage;
const paginator = document.getElementById("collection-pagination");
const collectionGrid = document.getElementById("collection-grid");
const paginationTriggers = document.querySelectorAll(".pagination-trigger");
const paginationControls = document.querySelector(".pagination-numbers");
const paginationNumbers = document.querySelectorAll(
  ".pagination-numbers button",
);
const leftArrow = document.querySelector(".left-arrow");
const rightArrow = document.querySelector(".right-arrow");
const leftPaginationNum = document.querySelector(".paginate-left");
const middlePaginationNum = document.querySelector(".paginate-middle");
const rightPaginationNum = document.querySelector(".paginate-right");
const lastPaginationNum = document.querySelector(".paginate-last");
const ellipsis = document.querySelector(".pagination-numbers .ellipsis");
let filters = {};
let filteredProducts = [];

const fetchCollectionPage = (page, handle) =>
  new Promise((resolve) => {
    const host = window.location.hostname;
    let collectionHandle = handle;
    if (collectionHandle.includes("?")) {
      collectionHandle = collectionHandle.split("?")[0];
    }
    fetch(
      `https://${host}/collections/${collectionHandle}?page=${page}&view=dictionary`,
      {
        method: "GET",
      },
    )
      .then((res) => res.text())
      .then((response) => {
        let products = response;
        products = products.split("let productDictionary = ");
        products = products[1].split(";window.products = productDictionary;");
        const pageProducts = JSON.parse(products[0]);
        pageProducts.forEach((product) => {
          product.collectionIndex =
            Number(product.collectionIndex) + productsPerPage * (page - 1);
          window.products.push(product);
        });
        resolve(true);
      });
  });

let productsInitialized = false;

if (window.collectionPages) {
  if (window.collectionPages < 2) {
    productsInitialized = true;
  } else {
    const productsToAdd = [];
    let i;

    for (i = 2; i <= window.collectionPages; i++) {
      productsToAdd.push(fetchCollectionPage(i, window.collectionHandle));
    }

    Promise.all(productsToAdd).then((response) => {
      productsInitialized = true;
      let toggle = false;
      let sort = false;
      let cancelContainer = ``;
      document.querySelectorAll(".filter-option").forEach((filter) => {
        if (filter.checked) {
          toggle = true;
          cancelContainer += `<div class="text-xs filter-cancel uppercase cursor-pointer" data-filter="${filter.dataset.filter}">${filter.dataset.filter} &times;</div>`;
        }
      });
      if (document.getElementById("sorter")) {
        if (sorter.value !== "Featured") {
          sort = true;
        }
      }
      if (toggle || sort) {
        document
          .getElementById("active-filter-container")
          .insertAdjacentHTML("beforeend", cancelContainer);
        document.querySelectorAll(".filter-cancel").forEach((cancel) => {
          if (!cancel.classList.contains("active-cancel")) {
            cancel.classList.add("active-cancel");
            cancel.addEventListener("click", cancelFilter);
            cancel.addEventListener("keydown", enterEvent);
          }
        });
        toggleFilter();
      }
    });
  }
}

// Reset controls if collection page has less than 3 pages of product on page load
if (window.products.length * collectionPages < productsPerPage * 3) {
  resetPaginationControls(
    collectionPages,
    productsPerPage,
    window.products.length,
  );
}

const calculateLastPage = (productsPerPage, numOfProducts) => {
  const lastPage = Math.ceil(numOfProducts / productsPerPage);
  if (lastPage > 3) {
    lastPaginationNum.style.display = "inline-block";
    if (parseInt(leftPaginationNum.dataset.value) + 3 >= lastPage) {
      ellipsis.classList.add("none");
    } else {
      ellipsis.classList.remove("none");
    }
  } else {
    if (lastPaginationNum) {
      lastPaginationNum.style.display = "none";
    }
    ellipsis.classList.add("none");
  }
};

function hasSwatch(arr) {
  return arr.find((product) => product.type === "Swatch");
}

const buildProducts = async (arr, initial, trigger, cartUpdate) => {
  if (productsInitialized) {
    arrLength = arr.length;
    // If initial is "STOP", we're at the last page
    initial =
      parseInt(initial) <= 0 || !initial
        ? 0
        : initial === "STOP"
          ? parseInt(productsPerPage * (window.currentPages - 1))
          : Math.floor(initial - productsPerPage);
    let max = Math.floor(initial + productsPerPage);
    const maxPages = Math.floor(arrLength / productsPerPage) + 1;
    let canBuild = true;
    // If a filter is set
    if (initial === 0) {
      if (collectionGrid) {
        collectionGrid.innerHTML = ``;
      }
      resetPaginationControls(maxPages, Math.abs(productsPerPage), arrLength);
    }
    // Determine if we can paginate and what products to load
    if (trigger) {
      if (
        (parseInt(trigger.dataset.value) - 1) * productsPerPage >=
        arrLength
      ) {
        return;
      }
      if (
        paginationControls.dataset.currentPage == trigger.dataset.value &&
        !cartUpdate
      ) {
        return;
      }
      [initial, max, canBuild] = updateInitialAndMax(
        initial,
        max,
        canBuild,
        productsPerPage,
        arrLength,
        trigger,
        cartUpdate,
      );
      calculateLastPage(productsPerPage, arrLength);
    } else {
      [initial, max, canBuild] = updateInitialAndMax(
        initial,
        max,
        canBuild,
        productsPerPage,
        arrLength,
        trigger,
        cartUpdate,
      );
      calculateLastPage(productsPerPage, arrLength);
    }

    // Sort the loaded products in our container
    let productContainer = ``;
    const sorting = document.getElementById("sorter").value;
    const resultsCount = document.querySelectorAll(".collection-results");
    if (resultsCount) {
      resultsCount.forEach((result) => {
        result.innerText = `${arr.length} RESULTS`;
      });
    }
    if (sorting == "Featured") {
      arr.sort((a, b) => a.collectionIndex - b.collectionIndex);
    } else if (sorting == "Alphabetical") {
      arr.sort((a, b) => {
        const fa = a.title.toLowerCase();
        const fb = b.title.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    } else if (sorting == "Price Low") {
      arr.sort((a, b) => {
        /**
         * 'price' and 'compareAtPrice' properties are set in collection--dictionary.liquid
         * Compare at price holds the product's sale price
         * It is used if it is less than the 'price'
         */
        const priceA = parseInt(a.price.replace("$", ""));
        const priceB = parseInt(b.price.replace("$", ""));

        const compareAtPriceA = a.compareAtPrice
          ? parseInt(a.compareAtPrice.replace("$", ""))
          : priceA;
        const compareAtPriceB = b.compareAtPrice
          ? parseInt(b.compareAtPrice.replace("$", ""))
          : priceB;

        if (compareAtPriceA < compareAtPriceB) {
          return -1;
        }
        if (compareAtPriceA > compareAtPriceB) {
          return 1;
        }
        if (priceA < priceB) {
          return -1;
        }
        if (priceA > priceB) {
          return 1;
        }
        return 0;
      });
    } else if (sorting == "Price High") {
      arr.sort((a, b) => {
        const priceA = parseInt(a.price.replace("$", ""));
        const priceB = parseInt(b.price.replace("$", ""));

        const compareAtPriceA = a.compareAtPrice
          ? parseInt(a.compareAtPrice.replace("$", ""))
          : priceA;
        const compareAtPriceB = b.compareAtPrice
          ? parseInt(b.compareAtPrice.replace("$", ""))
          : priceB;

        if (compareAtPriceA > compareAtPriceB) {
          return -1;
        }
        if (compareAtPriceA < compareAtPriceB) {
          return 1;
        }
        if (priceA > priceB) {
          return -1;
        }
        if (priceA < priceB) {
          return 1;
        }
        return 0;
      });
    } else if (sorting === "Best Sellers") {
      arr.sort((a, b) => {
        const fa = a.tags.includes("Best Seller");
        const fb = b.tags.includes("Best Seller");
        if (fa === true && fb === false) {
          return -1;
        }
        if (
          fa === true &&
          fb === true &&
          a.collectionIndex < b.collectionIndex
        ) {
          return -1;
        }
        if (fa === false && fb === true) {
          return 1;
        }
        return 0;
      });
    } else if (sorting === "New Arrivals") {
      arr.sort((a, b) => {
        const fa = new Date(
          a.published_at
            .substring(0, a.published_at.lastIndexOf("-") - 1)
            .replace(/-/g, "/"),
        );
        const fb = new Date(
          b.published_at
            .substring(0, b.published_at.lastIndexOf("-") - 1)
            .replace(/-/g, "/"),
        );
        if (fb < fa) {
          return -1;
        }
        if (fb > fa) {
          return 1;
        }
        return 0;
      });
    }
    let miniCart;
    if (hasSwatch(arr)) {
      miniCart = window.cart;
    }

    // Initiate building product cards
    for (let i = initial; i < max; i++) {
      if (i < arr.length) {
        const name = arr[i].title.split("-");
        let fabric = "";
        if (arr[i].type !== "Swatch") {
          allFabrics.forEach((f) => {
            if (
              arr[i].tags.includes(f) ||
              arr[i].tags.includes(f.toLowerCase())
            ) {
              fabric = f;
            }
          });
        }

        const tags = ``;
        let subhead = "";

        // Check for 'Satin' in case product has both tags (e.g. 'Satin' and 'Shiny Satin')
        if (
          (fabric === "Satin" && arr[i].tags.includes("Shiny Satin")) ||
          (fabric === "Satin" && arr[i].tags.includes("shiny satin"))
        ) {
          fabric = "Shiny Satin";
        }
        if (
          (fabric === "Satin" && arr[i].tags.includes("Matte Satin")) ||
          (fabric === "Satin" && arr[i].tags.includes("matte satin"))
        ) {
          fabric = "Matte Satin";
        }

        if (name[1]) {
          subhead += `<span class="plp-card-subhead"> ${fabric} ${name[1].replace(" in ", " ")}</span>`;
        }

        let availability = "";
        let stock = "";
        if (!arr[i].available && arr[i].tags.includes("Discontinued")) {
          availability += `unavailable-product`;
          stock += `<div class="flex uppercase items-center h-max text-terracotta"><svg class="w-[calc(7rem/9)] mr-1" viewBox="0 0 50 50">
            <g>
              <path fill="#d88473" d="M31.97,25.56c-2.21-1.17-4.65-1.79-6.97-1.79c-1.45,0-3,0.28-4.52,0.81c-2.29,0.79-4.54,2.14-6.28,4.05
                c-1.74,1.9-2.94,4.43-2.94,7.38c0,0.83,0.67,1.5,1.5,1.5c0.83,0,1.5-0.67,1.5-1.5h0c0-1.42,0.37-2.67,1.01-3.79
                c0.95-1.68,2.54-3.06,4.35-4.01c1.8-0.95,3.79-1.45,5.38-1.44c2.37-0.01,5.16,0.89,7.25,2.52c1.05,0.81,1.92,1.79,2.53,2.9
                c0.61,1.12,0.96,2.37,0.96,3.81c0,0.83,0.67,1.5,1.5,1.5c0.83,0,1.5-0.67,1.5-1.5c0-1.94-0.49-3.72-1.33-5.25
                C36.16,28.46,34.18,26.73,31.97,25.56z"/>
              <path fill="#d88473" d="M50,25c0-6.39-2.44-12.8-7.32-17.68C37.8,2.44,31.39,0,25,0C18.61,0,12.2,2.44,7.32,7.32
                C2.44,12.2,0,18.61,0,25c0,6.39,2.44,12.8,7.32,17.68C12.2,47.56,18.61,50,25,50c6.39,0,12.8-2.44,17.68-7.32l-1.06-1.06l1.06,1.06
                C47.56,37.8,50,31.39,50,25z M40.56,40.56L40.56,40.56C36.26,44.85,30.64,47,25,47c-5.64,0-11.26-2.15-15.56-6.44
                C5.14,36.26,3,30.64,3,25c0-5.64,2.15-11.26,6.44-15.56C13.74,5.15,19.36,3,25,3c5.64,0,11.26,2.15,15.56,6.44
                C44.85,13.74,47,19.36,47,25C47,30.64,44.85,36.26,40.56,40.56z"/>
              <path fill="#d88473" d="M16.61,21.11c1.21,0,2.44-0.47,3.36-1.39l-1.06-1.06l1.06,1.06c0.92-0.92,1.39-2.15,1.39-3.36
                c0-1.21-0.47-2.44-1.39-3.36c-0.92-0.93-2.15-1.39-3.36-1.39c-1.21,0-2.44,0.47-3.36,1.39c-0.93,0.92-1.39,2.15-1.39,3.36
                c0,1.21,0.47,2.44,1.39,3.36C14.18,20.64,15.4,21.11,16.61,21.11z M15.38,15.12c0.35-0.35,0.79-0.51,1.24-0.51
                c0.45,0,0.89,0.17,1.24,0.51c0.34,0.35,0.51,0.79,0.51,1.24c0,0.45-0.17,0.89-0.51,1.24l0,0c-0.35,0.34-0.79,0.51-1.24,0.51
                c-0.45,0-0.89-0.17-1.24-0.51c-0.35-0.35-0.51-0.79-0.51-1.24C14.86,15.91,15.03,15.47,15.38,15.12z"/>
              <path fill="#d88473" d="M33.38,21.11c1.21,0,2.44-0.47,3.36-1.39l-1.06-1.06l1.06,1.06c0.92-0.92,1.39-2.15,1.39-3.36
                c0-1.21-0.47-2.44-1.39-3.36c-0.92-0.93-2.15-1.39-3.36-1.39c-1.21,0-2.44,0.47-3.36,1.39c-0.93,0.92-1.39,2.15-1.39,3.36
                c0,1.21,0.47,2.44,1.39,3.36C30.95,20.64,32.17,21.11,33.38,21.11z M32.15,15.12c0.35-0.35,0.79-0.51,1.24-0.51
                c0.45,0,0.89,0.17,1.24,0.51c0.34,0.35,0.51,0.79,0.51,1.24c0,0.45-0.17,0.89-0.51,1.24l0,0c-0.35,0.34-0.79,0.51-1.24,0.51
                c-0.45,0-0.89-0.17-1.24-0.51c-0.35-0.35-0.51-0.79-0.51-1.24C31.63,15.91,31.8,15.47,32.15,15.12z"/>
            </g>
            </svg>
            OUT OF STOCK
          </div>`;
        } else if (!arr[i].available) {
          if (arr[i].type === "Swatch") {
            stock += `<div class="uppercase flex items-center text-liteSeaGlass">
							Coming soon - Join the waitlist
						  </div>`;
          } else {
            stock += `<div class="uppercase flex items-center text-[#7AA3A8]">
							WAITLIST
						  </div>`;
          }
        }

        /**
         * 'price' and 'compareAtPrice' properties are set in collection--dictionary.liquid
         * Compare at price holds the product's sale price
         * It is used if it is less than the 'price'
         */
        const price = parseInt(arr[i].price.replace("$", ""));
        const compareAtPrice = parseInt(arr[i].compareAtPrice.replace("$", ""));

        let tag = ``;
        let launchingTag = arr[i].tags.find((tag) =>
          tag.includes("badge:dresseslaunchingin"),
        );
        let launchingMonth = "";

        if (launchingTag) {
          launchingMonth = launchingTag.split("badge:dresseslaunchingin")[1];
          if (launchingMonth === "september")
            launchingMonth = launchingMonth.slice(0, 4);
          else if (launchingMonth.length > 5) {
            launchingMonth = launchingMonth.slice(0, 3);
          }
          launchingTag = `DRESSES LAUNCH ${launchingMonth}`;
        }

        if (arr[i].available) {
          if (arr[i].tags.includes("limited time price")) {
            tag = `<div class="icon-tag bg-[#4B5681] text-white">Limited Time Price</div>`;
          } else if (launchingTag) {
            tag = `<div class="icon-tag bg-litePink">${launchingTag}</div>`;
          } else if (arr[i].tags.includes("eoy2023")) {
            tag = `<div class="text-xs uppercase text-[#D20F56] py-0.5">Extra 20% off with code: SALESZN</div>`;
          } else if (arr[i].tags.includes("daily deal")) {
            tag = `<div class="text-xs uppercase text-oxfordBlue py-0.5">Daily Deal: Today Only!</div>`;
          } else if (arr[i].tags.includes("Best Seller")) {
            tag = `<div class="icon-tag bg-ndcPeach"><svg viewBox="0 0 50 50">
            <path class="" d="M49.77,19.25c-0.23-0.72-0.86-1.25-1.61-1.36L33.4,15.74l-6.6-13.38C26.46,1.68,25.76,1.25,25,1.25
              c-0.76,0-1.46,0.43-1.79,1.11l-6.6,13.38L1.84,17.89C1.09,18,0.46,18.53,0.23,19.25c-0.23,0.72-0.04,1.52,0.51,2.05l10.68,10.41
              l-2.52,14.7c-0.13,0.75,0.18,1.51,0.8,1.96c0.61,0.45,1.43,0.51,2.11,0.15L25,41.58l13.2,6.94c0.67,0.35,1.49,0.29,2.11-0.15
              c0.61-0.45,0.92-1.21,0.8-1.96l-2.52-14.7L49.27,21.3C49.81,20.77,50.01,19.97,49.77,19.25z M35.04,29.58
              c-0.47,0.46-0.69,1.12-0.58,1.77l2.01,11.74l-10.55-5.54c-0.58-0.3-1.28-0.3-1.86,0l-10.55,5.54l2.01-11.74
              c0.11-0.65-0.11-1.31-0.58-1.77l-8.53-8.32l11.79-1.71c0.65-0.09,1.22-0.51,1.51-1.09L25,7.77l5.27,10.69
              c0.29,0.59,0.86,1,1.51,1.09l11.79,1.71L35.04,29.58z"/>
            </svg> Best Seller</div>`;
          } else if (arr[i].tags.includes("badge:new luxe collection")) {
            tag = `<div class="icon-tag bg-navBadge">New Luxe Collection</div>`;
          } else if (arr[i].tags.includes("New Arrival")) {
            tag = `<div class="icon-tag bg-navBadge"><svg class="w-2" viewBox="0 0 50 50">
              <path class="" d="M44.55,23.29C35.74,17.96,29.76,10.8,27.37,3.02l-0.46-1.48c-0.26-0.85-1.07-1.43-1.96-1.41
                s-1.67,0.64-1.89,1.51l-0.65,2.56c-0.95,3.74-2.9,7.31-5.75,10.55c-2.85,3.24-6.59,6.13-11.09,8.47c-0.64,0.33-1.05,0.99-1.08,1.71
                c-0.02,0.72,0.35,1.4,0.96,1.78c8.81,5.33,14.78,12.49,17.18,20.27l0.46,1.48c0.26,0.85,1.07,1.43,1.96,1.41
                c0.89-0.02,1.67-0.64,1.89-1.51l0.65-2.56c0.95-3.74,2.9-7.31,5.75-10.55c2.85-3.24,6.59-6.13,11.09-8.47
                c0.64-0.33,1.05-0.99,1.08-1.71C45.53,24.34,45.16,23.66,44.55,23.29z M30.34,32.6c-2.4,2.73-4.29,5.73-5.55,8.92
                c-2.95-6.28-7.92-11.89-14.45-16.41c3.63-2.22,6.78-4.82,9.33-7.72c2.4-2.73,4.29-5.73,5.55-8.92c2.95,6.28,7.92,11.89,14.45,16.41
              C36.04,27.11,32.89,29.7,30.34,32.6z"/>
              </svg> New</div>`;
          } else if (arr[i].tags.includes("Discontinued")) {
            const discontinuationDate = arr[i].metafields?.discontinuation_date;
            tag = `<div class="icon-tag discontinued-tag bg-liteSeaGlass">${discontinuationDate ? `Discontinues on ${discontinuationDate}` : "Discontinued"}</div>`;
          } else if (arr[i].tags.includes("BMSMGR")) {
            tag = `<div class="suite-looks-tag flex items-center text-darkMauve">10% off with 4+ SUITELOOKS</div>`;
          } else if (arr[i].tags.includes("BMSMWP")) {
            tag = `<div class="tieoneon-tag flex items-center text-darkSeaGlass">20% off 4+ with TIEONEON</div>`;
          } else if (arr[i].tags.includes("$49VELVETDRESSES")) {
            tag = `<div class="tieoneon-tag flex items-center text-darkSeaGlass">$49 for Select Velvet Dresses</div>`;
          } else if (price > compareAtPrice) {
            const diff = price - compareAtPrice;
            tag = `<div class="icon-tag bg-terracotta"><svg viewBox="0 0 50 50">
              <g>
                <path class="" d="M36.73,8.23c-2.79,0-5.05,2.27-5.05,5.06c0,2.79,2.26,5.05,5.05,5.06c2.79,0,5.05-2.27,5.05-5.06
                  C41.78,10.49,39.53,8.23,36.73,8.23z M36.73,14.34c-0.58,0-1.05-0.47-1.05-1.06c0-0.59,0.47-1.06,1.05-1.06
                  c0.58,0,1.05,0.47,1.05,1.06C37.78,13.87,37.31,14.34,36.73,14.34z"/>
                <path class="st0" d="M49.9,16.09c0-8.84-7.15-16.01-15.98-16.01v2l0-2c-4.19,0-8.01,1.64-10.85,4.29
                  c-0.09,0.06-0.17,0.13-0.25,0.21L0.68,26.71c-0.78,0.78-0.78,2.05,0,2.83l19.79,19.79c0.37,0.37,0.89,0.59,1.41,0.59
                  c0.53,0,1.04-0.21,1.41-0.59L45.44,27.2c0.1-0.1,0.18-0.2,0.25-0.31C48.29,24.05,49.9,20.26,49.9,16.09z M21.89,45.09L4.93,28.12
                  L25.55,7.5c0.03-0.02,0.06-0.04,0.08-0.07c2.16-2.08,5.07-3.35,8.29-3.36c3.31,0,6.29,1.34,8.47,3.52c2.17,2.18,3.51,5.17,3.51,8.5
                  c0,3.22-1.27,6.13-3.33,8.3c-0.03,0.03-0.05,0.06-0.07,0.09L21.89,45.09z"/>
              </g>
            </svg> $${diff} off</div>`;
          }
        }

        let sellingFast = ``;
        let mtoVariantExists = false;
        let inventoryThreshold = 0;
        if (arr[i].variants.length) {
          if (
            arr[i].type == "Bridesmaid Dress" ||
            arr[i].type == "Groomsmen Accessory"
          ) {
            if (arr[i].type == "Bridesmaid Dress") {
              inventoryThreshold = 5;
            } else {
              inventoryThreshold = 10;
            }
            arr[i].variants.forEach((variant) => {
              if (!arr[i].tags?.includes("Discontinued")) {
                if (
                  variant.inventory > 0 &&
                  variant.inventory < inventoryThreshold
                ) {
                  sellingFast = `<div class="text-xs uppercase absolute selling-fast">SELLING FAST</div>`;
                }
                if (
                  variant.isMadeToOrder === true ||
                  variant.isPreorder === true
                ) {
                  mtoVariantExists = true;
                }
              }
            });
          }
        }

        if (mtoVariantExists) {
          sellingFast = ``;
        }

        let quickBuy = ``;

        if (arr[i].type == "Swatch" && arr[i].variants[0].available) {
          quickBuy = `<button id="add-${arr[i].handle}" data-location="collection page" data-quicktype="collection page" data-quickswatch="true" class="button atc uninitialized-atc button-primary quick-atc mt-2 w-full !py-2 tracking-wider" data-variantid="${arr[i].variants[0].id}" data-final-sale="${arr[i].tags.some((tag) => tag === "finalsale" || tag === "Final Sale")}">Add to Bag</button>`;
        }

        let primaryImg;
        let secondaryImg;

        if (arr[i].images) {
          primaryImg = arr[i].images[0];
          secondaryImg = arr[i].images[1];
        } else {
          (primaryImg = {
            alt: "We don't currently sell this product",
            height: 2048,
            src: "/cdn/shop/files/unavailable-core-1-1.jpg?v=1439483316397202521",
            width: 1366,
          }),
            (secondaryImg = {
              alt: "We don't currently sell this product",
              height: 2048,
              src: "/cdn/shop/files/unavailable-core-1-1.jpg?v=1439483316397202521",
              width: 1366,
            });
        }

        const newImg = new Image();
        newImg.src = primaryImg.src;

        let imageAlt = primaryImg.alt.trim().toLowerCase();
        let imageAlty = secondaryImg.alt.trim().toLowerCase();
        const secondary = secondaryImg.src;

        if (
          imageAlt.includes("dress") &&
          !imageAlt.includes("bridesmaid dress")
        ) {
          imageAlt = imageAlt
            .replace("dress", "bridesmaid dress")
            .replace("-", "in");
        }

        if (
          imageAlty.includes("dress") &&
          !imageAlty.includes("bridesmaid dress")
        ) {
          imageAlty = imageAlty
            .replace("dress", "bridesmaid dress")
            .replace("-", "in");
        }

        let hand = collectionHandle;
        if (hand.includes("/")) {
          hand = hand.split("/")[0];
        }
        if (hand.includes("?")) {
          hand = hand.split("?")[0];
        }

        let itemTitle = name[0];
        if (arr[i].type == "Bridesmaid Dress") {
          if (fabric) {
            itemTitle = itemTitle.replace(fabric, "");
          }
        }
        const isAdmin =
          document.getElementById("collection-grid").dataset.admin;

        function hideNoIndexProduct() {
          let result = "";
          if (arr[i]?.tags && arr[i].tags.includes("no-index")) {
            isAdmin === "false" ? (result = "none") : (result = "");
          } else {
            result = "";
          }
          return result;
        }

        productContainer += `
          <div class="flex flex-col justify-between ${hideNoIndexProduct()}">
            <a class="no-underline a11yajax" href="/collections/${hand}${arr[i].url}">
              <div class="${availability}">
                <div class="relative plp-image-container">
                  ${sellingFast}
                  <div class="plp-secondary absolute w-full">
                  <img alt="${itemTitle}" loading="lazy" width="${primaryImg.width}" height="${primaryImg.height}" src="${secondary}" />
                    ${sellingFast}
                </div>
                <img alt="${itemTitle}" loading="eager" width="${primaryImg.width}" height="${primaryImg.height}" src="${primaryImg.src}" />
              </div>
            <div class="grid plp-item-text"><div>
            <div class="flex flex-col">
              <span class="productCategory font-semibold capitalize">${itemTitle}</span>
              ${subhead}
            </div>
          </div>
        `;
        if (arr[i].available) {
          if (price > compareAtPrice) {
            productContainer += `<div aria-label="Original price ${arr[i].price}" class="bold collection-price"><div class="text-brand-darkerMocha line-through decoration-2"><span class="text-brand-deepMocha-75">${arr[i].price}</span></div>
              <div class="text-brand-darkerMocha" aria-label="Sale price ${arr[i].compareAtPrice}">${arr[i].compareAtPrice}</div></div>`;
          } else {
            if (arr[i].type === "Swatch" || arr[i].type === "Swatch Book") {
              productContainer += setSwatchPricePLP(arr[i], miniCart);
            } else {
              productContainer += `<div class="font-bold">${arr[i].price}</div>`;
            }
          }
        }
        productContainer += `
              </div>
              <div class="product-badges-container pt-1 grid grid-flow-col gap-1"> ${tag}${stock}</div>
              <div class="product-card-tags flex flex-wrap">
              ${tags}
                      </div>
                    </div>
                  </a>
              <div>
              ${quickBuy}
              </div>
            </div>
			 `;
      }
    }

    document
      .getElementById("collection-grid")
      .insertAdjacentHTML("beforeend", productContainer);
    document.getElementById("collection-grid").style.opacity = 1;

    if (paginator) {
      if (max < arr.length) {
        document.getElementById("collection-pagination").dataset.cursor = max;
      } else {
        document.getElementById("collection-pagination").dataset.cursor =
          "STOP";
      }
    }
    document.querySelectorAll(".uninitialized-atc").forEach((button) => {
      button.classList.remove("uninitialized-atc");
      button.addEventListener("click", atcClick);
      button.addEventListener("keydown", enterEvent);
    });
  } else {
  }
};

const handlePaginationUpdate = (products) => {
  window.currentPages = Math.floor(products.length / productsPerPage) + 1;
  scrollToPaginationControls();
};

paginationTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    let updatedProducts =
      filteredProducts.length > 0 ? filteredProducts : products;
    buildProducts(updatedProducts, paginator.dataset.cursor, trigger);
    handlePaginationUpdate(updatedProducts);
  });
});

if (hasSwatch(products)) {
  document.addEventListener("cartChange", () => {
    let updatedProducts =
      filteredProducts.length > 0 ? filteredProducts : products;
    buildProducts(
      updatedProducts,
      paginator.dataset.cursor,
      document.querySelector(".pagination-trigger.active-page"),
      true,
    );
    handlePaginationUpdate(updatedProducts);
  });
}

function updatePaginationControls(
  initial,
  productsPerPage,
  paginationTrigger,
  maxPages,
) {
  if (paginationTrigger) {
    const value = parseInt(paginationTrigger.dataset.value);
    leftArrow.dataset.value = value - 1;
    rightArrow.dataset.value = value + 1;
    if (parseInt(leftArrow.dataset.value) < 1) leftArrow.dataset.value = "1";
    if (parseInt(rightArrow.dataset.value) > maxPages)
      rightArrow.dataset.value = maxPages;

    // If there are only 3 pages or less
    if (maxPages <= 3) {
      leftPaginationNum.dataset.value = 1;
      middlePaginationNum.dataset.value = 2;
      rightPaginationNum.dataset.value = 3;
      lastPaginationNum.dataset.value = maxPages;
      ellipsis.classList.add("none");
    }
    // If last page is included in the range of pages
    else if (value + 3 >= maxPages) {
      leftPaginationNum.dataset.value = maxPages - 3;
      middlePaginationNum.dataset.value = maxPages - 2;
      rightPaginationNum.dataset.value = maxPages - 1;
      lastPaginationNum.dataset.value = maxPages;
      ellipsis.classList.add("none");
    }
    // Base case
    else {
      leftPaginationNum.dataset.value = value - 1;
      middlePaginationNum.dataset.value = value;
      rightPaginationNum.dataset.value = value + 1;
      if (
        leftPaginationNum.dataset.value < 1 ||
        leftPaginationNum.dataset.value == "NaN"
      ) {
        leftPaginationNum.dataset.value = 1;
        middlePaginationNum.dataset.value = 2;
        rightPaginationNum.dataset.value = 3;
        lastPaginationNum.dataset.value = maxPages;
      }
      ellipsis.classList.remove("none");
    }
    updatePaginationText();
  }
  if (paginationControls) {
    const currPage = initial / Math.abs(productsPerPage) + 1;
    paginationControls.dataset.currentPage = currPage;
  }
}

function updatePaginationText() {
  leftPaginationNum.innerText = leftPaginationNum.dataset.value;
  middlePaginationNum.innerText = middlePaginationNum.dataset.value;
  rightPaginationNum.innerText = rightPaginationNum.dataset.value;
  lastPaginationNum.innerText = lastPaginationNum.dataset.value;
}

function resetPaginationControls(
  maxPages,
  productsPerPage,
  totalAmountOfProducts,
) {
  if (
    leftPaginationNum != null ||
    middlePaginationNum != null ||
    rightPaginationNum != null ||
    lastPaginationNum != null
  ) {
    leftPaginationNum.dataset.value = "1";
    middlePaginationNum.dataset.value = "2";
    rightPaginationNum.dataset.value = "3";
    lastPaginationNum.dataset.value = maxPages;
    updatePaginationText();
    paginationControls.dataset.currentPage = "1";
    leftArrow.dataset.value = "1";
    rightArrow.dataset.value = "2";
    leftPaginationNum.classList.add("active-page");
    middlePaginationNum.classList.remove("active-page");
    rightPaginationNum.classList.remove("active-page");
    lastPaginationNum.classList.remove("active-page");

    if (
      leftPaginationNum.dataset.value * productsPerPage >
      totalAmountOfProducts
    ) {
      middlePaginationNum.style.display = "none";
      middlePaginationNum.classList.remove("cursor-pointer");
    } else {
      middlePaginationNum.style.display = "inline-block";
      middlePaginationNum.classList.add("cursor-pointer");
    }
    if (
      middlePaginationNum.dataset.value * productsPerPage >
      totalAmountOfProducts
    ) {
      rightPaginationNum.style.display = "none";
      rightPaginationNum.classList.remove("cursor-pointer");
    } else {
      rightPaginationNum.style.display = "inline-block";
      rightPaginationNum.classList.add("cursor-pointer");
    }
    if (maxPages < 2) {
      leftArrow.style.display = "none";
      leftArrow.classList.remove("cursor-pointer");
      rightArrow.style.display = "none";
      rightArrow.classList.remove("cursor-pointer");
    } else {
      leftArrow.style.display = "inline-block";
      leftArrow.classList.remove("cursor-pointer");
      rightArrow.style.display = "inline-block";
      rightArrow.classList.remove("cursor-pointer");
    }
  }
}

function updateInitialAndMax(
  initial,
  max,
  canBuild,
  productsPerPage,
  totalAmountOfProducts,
  trigger,
) {
  // Update initial and max
  if (collectionGrid) {
    collectionGrid.innerHTML = ``;
  }

  if (trigger) {
    const multiplier = parseInt(trigger.dataset.value) - 1;
    initial = Math.abs(multiplier * productsPerPage);
    max = Math.abs(initial) + Math.abs(productsPerPage);
  } else {
    initial = initial;
    max = Math.abs(initial + productsPerPage);
  }
  const maxPages = Math.floor(totalAmountOfProducts / productsPerPage) + 1;

  // Update pagination arrow values
  updatePaginationControls(initial, productsPerPage, trigger, maxPages);

  // Bold the current selected page
  if (trigger) {
    paginationNumbers.forEach((pageNumber) => {
      pageNumber.classList.toggle(
        "active-page",
        pageNumber.dataset.value === paginationControls.dataset.currentPage,
      );
    });
    // Adjusting navigation arrows
    const currentPageNumber = paginationControls.dataset.currentPage;
    const rightArrowColor = rightArrow.querySelector("svg path");
    const leftArrowColor = leftArrow.querySelector("svg path");
    if (currentPageNumber == rightArrow.dataset.value) {
      rightArrowColor.setAttribute("stroke", "var(--deepBeige-50)");
    } else {
      rightArrowColor.setAttribute("stroke", "var(--darkerMocha)");
    }

    if (currentPageNumber == leftArrow.dataset.value) {
      leftArrowColor.setAttribute("stroke", "var(--deepBeige-50)");
    } else {
      leftArrowColor.setAttribute("stroke", "var(--darkerMocha)");
    }
  }

  return [initial, max, canBuild];
}

function getScrollPosition(element) {
  let currenttop = 0;
  if (element.offsetParent) {
    do {
      currenttop += element.offsetTop;
    } while ((element = element.offsetParent));
    return [currenttop];
  }
}

function scrollToPaginationControls() {
  const topOfCollection =
    document.querySelector("#collection-wrapper") ||
    document.querySelector("#collection-grid");
  const heightOfNav = 140;
  window.scroll(0, getScrollPosition(topOfCollection) - heightOfNav);
}

function disableScroll() {
  // Get the current page scroll position
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  (scrollLeft = window.pageXOffset || document.documentElement.scrollLeft),
    // if any scroll is attempted, set this to the previous value
    (window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    });
}

const toggleFilterModal = (e) => {
  const filterModal = document.querySelector(".filter-container");
  if (filterModal) {
    filterModal.scrollTo(0, 0);
    filterModal.querySelectorAll(".open-tab").forEach((tab) => {
      tab.classList.remove("open-tab");
      const prev = tab.previousElementSibling;
      prev.querySelector(".tab-icon").innerText = "+";
    });
    if (filterModal.classList.contains("open-filter")) {
      filterModal.classList.remove("open-filter");
      filterModal.classList.remove("visible");
      document.querySelector(".filter-button").focus();
      document.querySelector(".filter-line-1").style.transform =
        `translate(0,3px) rotate(0deg)`;
      document.querySelector(".filter-line-2").style.transform =
        `translate(0,11px) rotate(0deg)`;
      document.querySelector(".filter-circle-1").style.opacity = `1`;
      document.querySelector(".filter-circle-2").style.opacity = `1`;
    } else {
      filterModal.classList.add("visible");
      filterModal.classList.add("open-filter");
      filterModal.focus();
      document.querySelector(".filter-line-1").style.transform =
        `translate(0,0) rotate(45deg)`;
      document.querySelector(".filter-line-2").style.transform =
        `translate(0,11px) rotate(-45deg)`;
      document.querySelector(".filter-circle-1").style.opacity = `0`;
      document.querySelector(".filter-circle-2").style.opacity = `0`;
      const closeSortMenu = () => {
        document
          .querySelector(".dropdown-container")
          .classList.remove("dropdown-active");
      };
      document.querySelectorAll(".close-sort-by").forEach((value) => {
        value.addEventListener("click", closeSortMenu);
      });
    }
  }
};

document.querySelectorAll(".filter-button").forEach((button) => {
  button.addEventListener("click", toggleFilterModal);
  button.addEventListener("keydown", enterEvent);
});

const cancelFilter = (e) => {
  const cancel = e.currentTarget;
  const { filter } = cancel.dataset;
  cancel.remove();
  filters = {};
  const quickFilters = [];
  let activeFilters = false;
  let availableNow = false;
  document.querySelectorAll(".filter-option").forEach((check) => {
    if (check.checked) {
      if (check.dataset.filter == filter) {
        check.checked = false;
      } else {
        activeFilters = true;

        const { option } = check.dataset;
        const { filter } = check.dataset;
        const { type } = check.dataset;
        if (filter == "Ships Now") {
          availableNow = true;
        }
        if (!filters[type]) {
          filters[type] = {};
        }
        if (filters[type][option]) {
          filters[type][option].push(filter);
        } else {
          filters[type][option] = [filter];
        }
      }
    }
  });

  const filtered = [];
  products.forEach((product) => {
    let included = true;
    if (availableNow) {
      let anyAvailable = false;

      // check that the variant is available and neither pre-order or made-to-order
      product.variants.forEach((variant) => {
        anyAvailable = isVariantReadyToShip(variant);
      });
      if (!anyAvailable) {
        included = false;
      }
    }
    for (const [key, value] of Object.entries(filters)) {
      let includesSize = false;
      let ind = 0;
      product.options.forEach((opt, index) => {
        if (opt.name.toLowerCase() == "size") {
          ind = index + 1;
        }
      });
      for (const [key1, value1] of Object.entries(value)) {
        if (key == "inventory" && key1 == "Size") {
          value1.forEach((size) => {
            product.variants.forEach((variant) => {
              if (ind !== 0) {
                let opt = variant[`option${ind}`];
                if (opt.includes("-")) {
                  opt = opt.split("-");
                } else {
                  opt = opt.split("/");
                }
                if (
                  opt.includes("1X") &&
                  opt.includes("3X") &&
                  !opt.includes("2X")
                ) {
                  opt.push("2X");
                }
                if (opt.includes(size)) {
                  if (variant.available) {
                    if (!availableNow) {
                      includesSize = true;
                    } else {
                      includesSize = isVariantReadyToShip(variant);
                    }
                  }
                }
              }
            });
          });
          if (!includesSize) {
            included = false;
          }
        } else if (key == "tag") {
          let includesTag = false;
          value1.forEach((tag) => {
            if (product.tags.includes(tag)) {
              includesTag = true;
            }
          });
          if (!includesTag) {
            included = false;
          }
        } else if (key == "price") {
          let includesPrice = false;
          const price = value1[0];
          if (parseInt(product.price.replace("$", "")) < price) {
            includesPrice = true;
          }
          if (!includesPrice) {
            included = false;
          }
        }
      }
    }
    if (included) {
      filtered.push(product);
    }
  });

  const collectionTop = document.getElementById("collection-wrapper");
  const header = document.querySelector("header");

  const headerHeight = header.offsetHeight;
  const topPosition = collectionTop.offsetTop - headerHeight;

  if (e) {
    if (!e.currentTarget.classList.contains("swatch-checkbox")) {
      window.scrollTo({
        top: topPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  if (activeFilters) {
    document.getElementById("clear-filters").classList.remove("none");
    document.querySelector(".see-filters").classList.remove("none");
    filteredProducts = filtered;
    setTimeout(() => {
      buildProducts(filtered, 0);
    }, 400);
  } else {
    document.getElementById("clear-filters").classList.add("none");
    document.querySelector(".see-filters").classList.add("none");
    filteredProducts = products;
    setTimeout(() => {
      buildProducts(products, 0);
    }, 400);
  }
};

const toggleFilter = (e) => {
  if (selectedColorSwatch) {
    localStorage.removeItem("selectedColorSwatch");
  }
  if (e) {
    e.preventDefault();
  }
  const pagination = document.getElementById("collection-pagination");
  if (pagination && pagination !== undefined && pagination !== "undefined") {
    document.getElementById("collection-pagination").dataset.cursor = "STOP";
  }

  filters = {};
  const quickFilters = [];
  let activeFilters = false;
  let availableNow = false;
  if (e) {
    const current = e.currentTarget;
    if (e.currentTarget.checked) {
      const filter = `<div role="button" tabindex="0" aria-label="Remove ${current.dataset.filter} filter" class="text-xs filter-cancel uppercase cursor-pointer" data-filter="${current.dataset.filter}">${current.dataset.filter} &times;</div>`;
      if (document.getElementById("active-filter-container")) {
        document
          .getElementById("active-filter-container")
          .insertAdjacentHTML("beforeend", filter);
      }
      document.querySelectorAll(".filter-cancel").forEach((cancel) => {
        if (!cancel.classList.contains("active-cancel")) {
          cancel.classList.add("active-cancel");
          cancel.addEventListener("click", cancelFilter);
          cancel.addEventListener("keydown", enterEvent);
        }
      });

      gtag({
        event: "filter_activation",
        filterName: current.dataset.filter,
        filterLocation: current.dataset.location,
      });
    }
  }
  document.querySelectorAll(".filter-option").forEach((check) => {
    if (check.checked) {
      activeFilters = true;

      const { option } = check.dataset;
      const { filter } = check.dataset;
      const { type } = check.dataset;
      if (filter == "Ships Now") {
        availableNow = true;
      }
      if (!filters[type]) {
        filters[type] = {};
      }
      if (filters[type][option]) {
        filters[type][option].push(filter);
      } else {
        filters[type][option] = [filter];
      }
    }
  });
  const filtered = [];
  products.forEach((product) => {
    let included = true;
    if (availableNow) {
      let unavailableCount = 0;

      // count the number of unavailable variants
      product.variants.forEach((variant) => {
        if (!isVariantReadyToShip(variant)) {
          unavailableCount++;
        }
      });

      if (unavailableCount > product.variants.length / 2) {
        included = false;
      }
    }
    for (const [key, value] of Object.entries(filters)) {
      let includesSize = false;
      let ind = 0;
      product.options.forEach((opt, index) => {
        if (opt.name.toLowerCase() == "size") {
          ind = index + 1;
        }
      });
      for (const [key1, value1] of Object.entries(value)) {
        if (key == "inventory" && key1 == "Size") {
          value1.forEach((size) => {
            product.variants.forEach((variant) => {
              if (ind !== 0) {
                let opt = variant[`option${ind}`];
                if (opt.includes("-")) {
                  opt = opt.split("-");
                } else {
                  opt = opt.split("/");
                }
                if (
                  opt.includes("1X") &&
                  opt.includes("3X") &&
                  !opt.includes("2X")
                ) {
                  opt.push("2X");
                }
                if (opt.includes("XS") && opt.includes("XL")) {
                  if (!opt.includes("S")) {
                    opt.push("S");
                  }
                  if (!opt.includes("M")) {
                    opt.push("M");
                  }
                  if (!opt.includes("L")) {
                    opt.push("L");
                  }
                }
                if (opt.includes(size)) {
                  if (variant.available) {
                    if (!availableNow) {
                      includesSize = true;
                    } else {
                      includesSize = isVariantReadyToShip(variant);
                    }
                  }
                }
              }
            });
          });
          if (!includesSize) {
            included = false;
          }
        } else if (key == "tag") {
          let includesTag = false;
          value1.forEach((tag) => {
            if (product.tags.includes(tag)) {
              includesTag = true;
            }
          });
          if (!includesTag) {
            included = false;
          }
        } else if (key == "price") {
          let includesPrice = false;
          const price = value1[0];
          if (parseInt(product.price.replace("$", "")) < price) {
            includesPrice = true;
          }
          if (!includesPrice) {
            included = false;
          }
        } else if (key === "variant-metafield") {
          let variantsWithMetafield = 0;
          if (product.variants) {
            variantsWithMetafield = product.variants.reduce(
              (prevValue, variant) => {
                if (variant[value1] === true) {
                  return prevValue + 1;
                }
                return prevValue;
              },
              0,
            );
          }
          if (variantsWithMetafield <= product.variants.length / 2) {
            included = false;
          }
        }
      }
    }
    if (included) {
      filtered.push(product);
    }
  });

  const collectionTop = document.getElementById("collection-wrapper");
  const header = document.querySelector("header");

  const headerHeight = header.offsetHeight;
  let topPosition;
  if (collectionTop) {
    topPosition = collectionTop.offsetTop - headerHeight;
  }
  if (e && collectionTop) {
    if (!e.currentTarget.classList.contains("swatch-checkbox")) {
      window.scrollTo({
        top: topPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  const activeContainer = document.getElementById("active-filter-container");
  if (activeFilters && activeContainer) {
    document.getElementById("active-filter-container").classList.remove("none");
    filteredProducts = filtered;
    setTimeout(() => {
      buildProducts(filtered, 0);
    }, 400);
  } else if (activeContainer) {
    document.getElementById("active-filter-container").classList.add("none");
    filteredProducts = products;
    setTimeout(() => {
      buildProducts(products, 0);
    }, 400);
  } else {
    filteredProducts = filtered;
    setTimeout(() => {
      buildProducts(filtered, 0);
    }, 400);
  }
};

const clearFilters = () => {
  document.querySelectorAll(".filter-cancel").forEach((cancel) => {
    cancel.remove();
  });
  document.querySelectorAll(".filter-option").forEach((toggle) => {
    toggle.checked = false;
  });
  document.getElementById("clear-filters").classList.add("none");
  document.querySelector(".see-filters").classList.add("none");
  document.getElementById("filter-container").focus();
  filteredProducts = products;
  buildProducts(products, 0);
};

document.querySelectorAll(".filter-option").forEach((filter) => {
  filter.addEventListener("change", toggleFilter);
});

const switchGrid = (e) => {
  const t = e.currentTarget;
  const columns = e.currentTarget.dataset.switch;
  const grid = document.getElementById("collection-grid");
  const type = e.currentTarget.dataset.grid;
  if (type == "mobile") {
    grid.classList.remove("tg1");
    grid.classList.remove("tg2");
    grid.classList.add(`tg${columns}`);
  } else {
    grid.classList.remove("dg2");
    grid.classList.remove("dg4");
    grid.classList.add(`dg${columns}`);
    if (columns == 2) {
      grid.classList.remove("text-xs");
      grid.classList.add("text-sm");
    } else {
      grid.classList.remove("text-sm");
      grid.classList.add("text-xs");
    }
  }
  document.querySelectorAll(".grid-switcher").forEach((switcher) => {
    if (switcher == t) {
      switcher.classList.add("active-grid-switcher");
    } else if (switcher.dataset.grid == type) {
      switcher.classList.remove("active-grid-switcher");
    }
  });
};

const sortProducts = (e) => {
  if (filteredProducts.length > 0) {
    buildProducts(filteredProducts, 0);
  } else {
    buildProducts(products, 0);
  }
};
if (document.getElementById("sorter")) {
  document.getElementById("sorter").addEventListener("change", sortProducts);
  document.getElementById("sorter").addEventListener("input", sortProducts);
}

// ADA - Sort By Filter
const sortByContainer = document.querySelector(".collection--sort-by-filter");

if (sortByContainer) {
  const sortByButton = sortByContainer.querySelector(".sort-by-button");
  const sortByDropdown = sortByContainer.querySelector(".dropdown-container");

  const sortHandleMouseEvent = (e, action) => {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    if (isDesktop) {
      window.sort[action]();
    }
  };

  const sortHandleKeyDown = (e) => {
    const isOpen = sortByDropdown.classList.contains("dropdown-active");
    const enterOrSpaceKeys = e.key === "Enter" || e.key === " ";
    const escapeKey = e.key === "Escape";

    if (e.target === sortByButton) {
      if (enterOrSpaceKeys) {
        e.preventDefault();
        isOpen ? window.sort.closeMenu() : window.sort.openMenu();
      }
    } else if (escapeKey && isOpen) {
      window.sort.closeMenu();
    }
  };

  // Event Listeners
  sortByButton.addEventListener("mouseover", (e) =>
    sortHandleMouseEvent(e, "openMenu"),
  );
  sortByContainer.addEventListener("mouseleave", (e) =>
    sortHandleMouseEvent(e, "closeMenu"),
  );
  sortByButton.addEventListener("keydown", sortHandleKeyDown);
  sortByDropdown.addEventListener("keydown", sortHandleKeyDown);

  document.querySelectorAll(".grid-switcher").forEach((switcher) => {
    switcher.addEventListener("click", switchGrid);
  });
}

let activeFilters = false;

document.querySelectorAll(".filter-option").forEach((filter) => {
  if (filter.checked) {
    activeFilters = true;
  }
});

const setPrefilters = () => {
  if (productsInitialized) {
    toggleFilter();
  } else {
    setTimeout(() => {
      setPrefilters();
    }, 250);
  }
};

const setDescription = () => {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  let characterLimit;
  if (isMobile) {
    characterLimit = 65;
  } else {
    characterLimit = 170;
  }
  const collectionDescription = document.querySelector(
    ".collection-description",
  );
  if (collectionDescription) {
    if (collectionDescription.innerText.length > characterLimit) {
      const preview = `<span>${collectionDescription.innerHTML.substring(
        0,
        characterLimit,
      )}</span>`;
      const extended = `<span class="none extended-text">${collectionDescription.innerHTML.substring(
        characterLimit,
      )} </span>`;
      const ellipsis = `<span class="extended-text">... </span>`;
      const toggle = `<span class="text-brand-darkerMocha cursor-pointer read-more font-semibold underline">READ MORE</span>`;
      let isExtended = false;

      collectionDescription.innerHTML = preview + extended + ellipsis + toggle;
      const readMore = document.querySelector(".read-more");
      const extendedText = document.querySelectorAll(".extended-text");

      readMore.addEventListener("click", () => {
        if (!isExtended) {
          readMore.innerText = "READ LESS";
        } else {
          readMore.innerText = "READ MORE";
        }
        isExtended = !isExtended;
        extendedText.forEach((text) => {
          text.classList.toggle("none");
        });
      });
    }
  }
};

setDescription(170, 65);

if (activeFilters) {
  setPrefilters();
}
